import React, { useState, useEffect } from "react";
import { useUserAuth } from "../context/UserAuthContext";
import Loader from "./Loader";
import Back from '../images/back2.webp';
import Nav from "./Nav";
import Dashboard from "./Dashboard";
import '../styles/Home.css';
import Notifications from "./Notifications";
import { db } from '../config/fbConfig';
import { collection, getDocs } from 'firebase/firestore';
import Guidelines from "./Guidelines";
import Management from "./Management";

const Home = () => {
  const { userData } = useUserAuth();
  const [activeComponent, setActiveComponent] = useState(() => {
    // Initialize from localStorage, default to 'dashboard'
    return localStorage.getItem('activeComponent') || 'dashboard';
  });
  const [loading, setLoading] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    loadImage(Back).then(() => setLoading(false));
  }, []);

  // Persist activeComponent to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('activeComponent', activeComponent);
  }, [activeComponent]);

  // Fetch notifications data and set count based on user status
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const notificationsCollectionRef = collection(db, 'notifications');
        const notificationsSnapshot = await getDocs(notificationsCollectionRef);
        let notifications = notificationsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Filter notifications for non-Admin users
        if (userData?.status !== "Admin") {
          notifications = notifications.filter(notification => 
            notification.audience === userData?.status || 
            notification.audience === "All" || 
            !notification.audience
          );
        }

        setNotificationCount(notifications.length);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    if (userData) {
      fetchNotifications();
    }
  }, [userData]);

  if (loading) {
    return <Loader />;
  }

  const handleButtonClick = (component) => {
    setActiveComponent(component);
  };

  const isInactiveTeacherOrParent = userData && 
  (userData.status === "Teacher" || userData.status === "Parent") && 
  userData.isActive === false;

  if (!userData) {
    return <Loader text={"LOADING"}/>;
  }

  return (
    <>    
      <Nav />
      <div className="login-page-items homepage-back" style={{backgroundImage: `url(${Back})`}}>   
        {
          isInactiveTeacherOrParent ? (
            <span className="nav-links text-center font-red">{userData.firstName}, please contact school admin</span>
          ) : (
            <ul className="nav-links row align-center">
              <li>
                <button onClick={() => handleButtonClick('dashboard')} className={`nav-link plain-button column align-center ${activeComponent === 'dashboard' ? 'active' : ''}`}>
                  <i className="fa-solid fa-solid fa-chart-simple size2"></i> <span className="size5">Dashboard</span>
                </button>
              </li>
              <li>
                <button onClick={() => handleButtonClick('management')} className={`nav-link plain-button column align-center ${activeComponent === 'management' ? 'active' : ''}`}>
                  <i className="fa-solid fa-chalkboard-user size2"></i> <span className="size5">Management</span>
                </button>
              </li>
              <li>
                <button onClick={() => handleButtonClick('guidelines')} className={`nav-link plain-button column align-center ${activeComponent === 'guidelines' ? 'active' : ''}`}>
                  <i className="fa-solid fa-book size2"></i> <span className="size5">Guidelines</span>
                </button>
              </li>
              <li>
                <button onClick={() => handleButtonClick('notifications')} className={`nav-link plain-button column align-center ${activeComponent === 'notifications' ? 'active' : ''}`}>
                  <div className="">
                    <i className="fa-solid fa-bell size2"></i>
                    <span className={`notifications-counter ${activeComponent === 'notifications' ? 'active' : ''}`}>{notificationCount}</span> <span className="size5">Notifications</span>
                  </div>
                </button>
              </li>
            </ul>
          )
        }       

        <div className="scroll-fixed scroll-fixed4" style={{ display: activeComponent === 'dashboard' ? 'block' : 'none' }}>
          <Dashboard />
        </div>
        <div className="scroll-fixed scroll-fixed4" style={{ display: activeComponent === 'management' ? 'block' : 'none' }}>
          <Management />
        </div>
        <div style={{ display: activeComponent === 'guidelines' ? 'block' : 'none' }}>
          <Guidelines />
        </div>
        <div style={{ display: activeComponent === 'notifications' ? 'block' : 'none' }}>
          <Notifications />
        </div>
      </div>
    </>
  );
};

export default Home;